<template>
  <div class="flex items-center justify-center gap-2 color-primary absolute bg-primary6 h-[40px]">
    <CButton
      v-tooltip="t('canvasUI.canvasBuilder.components.block.saveForMe')"
      :loading="isSaving"
      text
      @click="emit('save')"
    >
      <template #icon>
        <CIcon icon="floppy-disk" size="16" />
      </template>
      {{ t('canvasUI.canvasBuilder.components.block.saveForMe') }}
    </CButton>
    <CButton v-tooltip="t('canvasUI.common.remove')" class="w-9 h-9" text @click="emit('remove')">
      <template #icon>
        <CIcon :color="themeVars.error" icon="trash" size="16" />
      </template>
    </CButton>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import CIcon from '@lib/components/CIcon/CIcon.vue'
import CButton from '@lib/components/CButton/CButton.vue'
import useThemeVars from '@lib/composables/useThemeVars'

defineProps<{
  isSaving: boolean
}>()
const emit = defineEmits<{
  (e: 'save'): void
  (e: 'remove'): void
}>()

const themeVars = useThemeVars()
const { t } = useI18n()
</script>
